var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotateArrowFifth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(0 1 -1 0 21 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.11111 7.44457v-3.44816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.55927 3.99641h-3.44816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.40245 4.68966c3.4697711 1.64442314 5.2926983 5.5126599 4.3522436 9.2354256-.9404548 3.7227656-4.3818318 6.2611201-8.2162968 6.0603281-3.83446492-.200792-6.99190513-3.084694-7.5383968-6.8853237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.6592 3.99647c-.0000331.02759729-.0224193.04994916-.0500167.04993995-.0275973-.00000921-.0499685-.02237602-.0499833-.04997332-.0000147-.02759731.0223327-.04998797.04993-.05002663.0132834-.00001861.0260281.00524926.0354218.01464108s.0146642.02213556.0146482.03541892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.10364 5.3298c-.00003314.02759859-.02242137.04995101-.05001998.04993996-.0275986-.00001105-.04996893-.02238138-.04997998-.04997998-.00001105-.02759861.02234137-.04998684.04993996-.05001998.01328162-.00001595.02602384.00525309.03541538.01464462.00939153.00939154.01466057.02213376.01464462.03541538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.45 8.44092c-.00003866.02759728-.02242932.04994468-.05002663.04992996-.0275973-.00001473-.04996411-.02238601-.04997332-.04998331s.02234266-.04998351.04993995-.05001665c.01328336-.00001595.0260271.00525446.03541892.01464816.00939182.00939369.01465969.02213849.01464108.03542184"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 24v-24h24v24z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateArrowFifth);
export default __webpack_public_path__ + "static/media/rotate-arrow-fifth.ca81f1da86bf26bcb61217ee6c5be088.svg";
export { ForwardRef as ReactComponent };